import React from 'react';

import TranslatedCopy from '../../intl/translated-copy';

const FormInputLabel = props => {
  const {
    name,
    isRequired,
    label,
    labelClassModifier,
    labelCopyID,
    optionalClass,
    showOptionalLabel,
  } = props;

  return (
    <label
      aria-required={ isRequired }
      className={ `FormInput-label FormInput-label--${labelClassModifier} ${optionalClass}` }
      htmlFor={ name }>
      { labelCopyID ?
        typeof(labelCopyID) !== 'string' ? labelCopyID : <TranslatedCopy copyID={ labelCopyID } /> : label }
      { !isRequired && showOptionalLabel ?
        <span className='FormInput-labelOptional'> (<TranslatedCopy copyID='APP_OPTIONAL' />)</span> : null }
    </label>
  );
};

FormInputLabel.defaultProps = {
  showOptionalLabel: false,
};

export default FormInputLabel;
